// Espejo frontend del kill-switch de apreciación (backend:
// src/config/appreciation.ts). Decisión Douglas 2026-07-03
// (internal/specs/apreciacion-apagada-v1.md): la apreciación no se usa en v1;
// la UI se oculta pero la lógica (y el backend de reference-tables) queda
// intacta y dormida.
//
// Gates que dependen de esta constante:
// - AjustesPage: tarjeta "Valores referenciales" oculta.
// - router: /app/ajustes/valores-referenciales redirige a /app/ajustes.
// - AppreciationStaleBanner: retorna null (cubre Depreciación y Valores
//   referenciales sin depender del stale=false del backend).
//
// Cómo revertir: poner en `true` acá y en el backend, y correr el recompute
// por cuenta para ponerse al día. Tipado `boolean` (no literal `false`) para
// que los gates no se lean como código muerto por el narrowing de TS.
export const APPRECIATION_ENABLED: boolean = false;
